import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./SliderSection.css";

const SliderSection = ({ onRegisterClick }) => {
  const settings = {
    dots: false, // Remove navigation dots
    infinite: true, // Loop images infinitely
    speed: 2000, // Smooth transition speed (2 seconds)
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable automatic sliding
    autoplaySpeed: 5000, // 5 seconds per slide (faster)
    lazyLoad: "ondemand", // Load images only when needed
    swipe: true, // Enable swiping to improve UX
    draggable: true, // Allow mouse drag
    arrows: false, // Remove navigation arrows
    pauseOnHover: false, // Prevent pausing when hovered
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {[1, 2, 3].map((num) => (
          <div key={num} className="slide">
            {/* Apply zoom-in effect directly to the image */}
            <motion.img
              src={`/slider-image${num}.jpg`}
              alt={`Offroad ${num}`}
              className="slide-image"
              initial={{ scale: 1 }}
              animate={{ scale: 1.2 }} // Less intense zoom effect
              transition={{ duration: 5, ease: "linear" }} // Faster animation
            />
          </div>
        ))}
      </Slider>

      {/* Animated Text */}
      <motion.div
        className="text-overlay"
        initial={{ x: "-100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h1>RESULTS</h1>
        <button className="register-button" onClick={onRegisterClick}>
          ENTER NOW
        </button>
      </motion.div>
    </div>
  );
};

export default SliderSection;
